import type { RouteRecordRaw } from 'vue-router';

import { ROUTES } from '@/constants/routes';
import i18n from '@/i18n';

import type { BreadcrumbProps } from '@/dsComponents/breadcrumbs/types';

const routesInApp: RouteRecordRaw[] = [
	{
		path: 'active-proposition',
		name: ROUTES.APP.ACTIVE_PROPOSITION._ROOT,
		redirect: (to) => ({
			name: ROUTES.APP.ACTIVE_PROPOSITION.PROPOSITIONS,
			query: to.query,
		}),
		component: () =>
			import(
				/* webpackChunkName: "ap-layout" */ './views/ActivePropositionLayout.vue'
			),
		children: [
			{
				path: 'propositions',
				name: ROUTES.APP.ACTIVE_PROPOSITION.PROPOSITIONS,
				component: () =>
					import(
						/* webpackChunkName: "ap-proposition" */ './views/Propositions.vue'
					),
				meta: {
					breadcrumbs: <BreadcrumbProps>{
						items: [
							{
								label: i18n.global.t('breadcrumbs.activeProposal.root'),
								icon: 'mail-arrow-right',
								link: { name: ROUTES.APP.ACTIVE_PROPOSITION._ROOT },
							},
						],
					},
				},
			},
			{
				path: 'company-need-propositions',
				name: ROUTES.APP.ACTIVE_PROPOSITION.COMPANY_NEED_PROPOSITIONS,
				component: () =>
					import(
						/* webpackChunkName: "ap-proposition" */ './views/Propositions.vue'
					),
				meta: {
					breadcrumbs: <BreadcrumbProps>{
						items: [
							{
								label: i18n.global.t('breadcrumbs.activeProposal.root'),
								icon: 'mail-arrow-right',
								link: { name: ROUTES.APP.ACTIVE_PROPOSITION._ROOT },
							},
						],
					},
				},
			},
			{
				path: 'envoi/:workerId?',
				name: ROUTES.APP.ACTIVE_PROPOSITION.SEND,
				component: () =>
					import(
						/* webpackChunkName: "ap-proposition" */ './views/SendActiveProposition.vue'
					),
				// Route is now always accessible - feature checks removed
			},
			{
				path: 'companies',
				name: ROUTES.APP.ACTIVE_PROPOSITION.COMPANIES,
				component: () =>
					import(
						/* webpackChunkName: "ap-companies" */ './views/Companies.vue'
					),
				meta: {
					breadcrumbs: <BreadcrumbProps>{
						items: [
							{
								label: i18n.global.t('breadcrumbs.activeProposal.root'),
								icon: 'mail-arrow-right',
								link: { name: ROUTES.APP.ACTIVE_PROPOSITION._ROOT },
							},
						],
					},
				},
			},
		],
	},
];

const externalRoutes: RouteRecordRaw[] = [
	{
		path: '/active-proposition-response/:status',
		name: ROUTES.ACTIVE_PROPOSAL_RESPONSE,
		component: () =>
			import(
				/* webpackChunkName: "pa-module" */ './views/ActivePropositionResponse.vue'
			),
	},
];

export { externalRoutes, routesInApp };
